exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rx-input-row{display:flex;flex-flow:row;align-items:center;color:#f0f1ef;width:100%}.rx-input-row .label{display:flex;height:30px;align-items:center;padding-left:6px;color:#c2c2c2;font-size:12px;width:100px;flex-shrink:0}.rx-input-row.changed .label{color:#7c9161}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f888448","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shell/components/inputs/RxInputRow.vue
// module id = 76
// module chunks = 0 1